// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"063dd238","453":"c75ac291","618":"bff5220f","653":"3f6d9cb7","725":"651950aa"}[chunkId] + ".chunk.js";
};